import * as types from '../mutation-types';
import order from '../../api/order';

const state = {
  orders: [],
  pagination: null,
  detail: {},
  // 準備集運的郵包
  orderParcels: [],
  orderUnpaidOrderIds: [],
};

const getters = {};

const actions = {
  fetchOrders({ commit }, params) {
    return order.get(params).then(({ data: response }) => {
      commit(types.RECEIVE_ORDERS, response);
      return response.data;
    });
  },
  submitOrder({ dispatch }, params) {
    return order.post(params).then(({ data: response }) => {
      dispatch('fetchOrders');
      return response.data;
    });
  },
  checkUnpaidOrder({ commit }) {
    return order.checkUnpaidOrder().then(({ data: response }) => {
      commit(types.RECEIVE_ORDER_UNPAID_COUNT, response.ids);
    });
  },
};

/* eslint no-param-reassign: 0, no-shadow: 0 */
const mutations = {
  [types.RECEIVE_ORDERS](s, response) {
    s.orders = response.data;
    s.pagination = response.meta.pagination;
  },
  [types.RECEIVE_ORDER_DETAIL](s, response) {
    s.detail = response.data;
  },
  [types.RECEIVE_ORDER_UNPAID_COUNT](s, data) {
    s.orderUnpaidOrderIds = [...data];
  },
  saveOrderParcels(s, parcels) {
    s.orderParcels = [...parcels];
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/order.js